export default {
    // --------Title--------
    modifyContainer: '修改货柜',
    container: '货柜',
    registeredContainerInformation: '货柜注册信息',
    detailInformationAboutTheItemsInvolved: '物品详细信息',
    uploadExcel: '上传Excel',
    selectThePackingDocumentToImport: '选择要导入的包装文件',
    provideInformationAboutContainer: '提供关于货柜信息',
    availableProducts: '可用商品',
    availableItems: '可用物品',
    containerInformation: '货柜信息',
    detailsInformationAboutContainer: '货柜完整详细信息',
    searchSupplierNoOrSignedByOrMarking: `搜寻 厂家/公司/单号/名 / 签收人 / 唛头`,
    modifyLoadContainerDateTime: `更改装柜时间`,

    // --------Dialog & Drawer Title-------
    addContainerItems: '添加货柜物品',
    customerMarking: '客户唛头',
    searchCustomerDetailsByMarking: '以唛头搜索客户详细信息',
    searchCustomerByMarking: '通过唛头搜索客户',
    updateContainerInformation: '更新货柜信息',
    relatedWarehouseLocationToProcess: '处理相关仓库位置',
    fileName: '文件名称 :',
    calculateTheSummaryOfTheContainerInformationPerformValidationBeforeImportIntoSystem: '让系统计算汇总货柜信息，并在导入系统前进行验证',
    updateRemark: '更新备注',
    proofOfDelivery: '追踪货柜状态',
    proofOfDeliveryDetails: '追踪货柜状态信息',

    // ----------MUI--------
    modify: '修改',
    importPackingExcel: '导入包装Excel文件',
    downloadPackingExcelFull: '下载装柜单 (完整)',
    downloadPackingExcelSimple: '下载装柜单 (简约)',
    repositoryNo: '货柜号',
    repositoryAltNo: '货柜备用号',
    containerNo: '货柜号',
    secondaryNo: '货柜备用号',
    sealNo: '封条号',
    loadDate: '装柜日期',
    customAgent: '报关代理',

    locationName: '仓库',
    destinationLocation: '目的地',
    action: '操作',
    containerSize: '货柜尺寸',
    containerType: '货柜类型',
    repositoryMarking: '货柜代号',
    initialDate: '注册日期',
    supervisor: '监柜人',
    shipper: '船运公司',
    totalPackQty: '总件数',
    totalValues: '总价值',
    totalWeight: '总重量',
    totalCbm: '总立方',

    splitProductItems: '进行分批装柜',
    status: '状态',
    courierNo: '快递单号',
    purchaseNo: '采购单号',
    packQty: '包装数量',
    values: '价值',
    weight: '重量',
    qty: '数量',
    signedBy: '收件人',
    loadDateTime: '装柜时间',
    createdatetime: '创建时间',
    no: '序号',
    dimension: '尺寸 (长x高x宽)',
    used: '已用',
    loadQty: '上柜数量',
    createDateTime: '创建时间',
    uploadFile: '上传文件',
    downloadTemplate: '下载模板',
    confirmImport: '确认导入',
    close: '关闭'

}